function generateTimeList(formato = '24h', intervalo = 30) {
  const listaHoraria = [];
  const minutosPorHora = 60;

  // Validar el intervalo
  if (minutosPorHora % intervalo !== 0) {
    throw new Error('El intervalo debe ser un divisor de 60 (ej: 15, 30, 60).');
  }

  // Determinar el límite de horas según el formato
  const limiteHoras = formato === '12h' ? 12 : 24;

  for (let hora = 0; hora < limiteHoras; hora += 1) {
    for (let minuto = 0; minuto < minutosPorHora; minuto += intervalo) {
      let horaFormateada;
      let periodo = '';

      // Formatear la hora según el formato seleccionado
      if (formato === '12h') {
        horaFormateada = String(hora % 12 || 12).padStart(2, '0'); // Convierte 0 a 12
      } else if (formato === '24h') {
        horaFormateada = String(hora).padStart(2, '0');
        // Determinar AM o PM para el formato de 24 horas
        periodo = hora < 12 ? 'AM' : 'PM';
      } else {
        throw new Error('Formato no válido. Use "12h" o "24h".');
      }

      // Formatear los minutos
      const minutoFormateado = String(minuto).padStart(2, '0');

      // Agregar a la lista
      if (formato === '12h') {
        listaHoraria.push({ Format: '12h', Hora: `${horaFormateada}:${minutoFormateado}` });
      } else if (formato === '24h') {
        listaHoraria.push({ Format: '24h', Hora: `${horaFormateada}:${minutoFormateado} ${periodo}` });
      }
    }
  }

  return listaHoraria;
}

export default generateTimeList;
